import { render, staticRenderFns } from "./UsersInvitationsTable.vue?vue&type=template&id=049ff26e&"
import script from "./UsersInvitationsTable.vue?vue&type=script&lang=js&"
export * from "./UsersInvitationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports